/** Placeholder image for package tiles in website builder and previews. */
export const PACKAGE_ICON_FALLBACK = 'assets/images/website-builder/package_icon.png';
